<input
    class="form-check-input"
    type="checkbox"
    [id]="inputId"
    [checked]="checked"
    [disabled]="isDisabled"
    (change)="onChanged($event)"
    (blur)="onTouched()"
/>